import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  FormControl,
  Input,
  FormLabel,
  Divider,
  Checkbox,
  Tooltip,
  Select,
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import "./Rating.css";

const Rating = ({ field, handleOnChange }) => {
  const styleClasses = field.styleClasses.length
    ? field.styleClasses.join(" ")
    : "";
  return (
    <Box mt="16px" w="380px" h="333.93">
      <FormControl mb="12px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Label
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          borderRadius="4px"
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          type="text"
          value={field.label}
          placeholder="Enter label"
          onChange={(e) => handleOnChange(e, "label")}
        />
        <Checkbox
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          mt="12px"
          isChecked={field.showLabel}
          onChange={(e) => handleOnChange(e, "showLabel")}
        >
          Show label
        </Checkbox>
      </FormControl>
      <FormControl>
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Rating scale of
        </FormLabel>
        <Select
          w="378px"
          h="32px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          borderRadius="4px"
          onChange={(e) => handleOnChange(e, "ratingScale")}
          value={field.ratingScale}
        >
          <option value="5">5</option>
          <option value="4">4</option>
          <option value="3">3</option>
          <option value="2">2</option>
          <option value="1">1</option>
        </Select>
      </FormControl>
      <FormControl mt="12px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Default rating
        </FormLabel>
        <Select
          w="378px"
          h="32px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          borderRadius="4px"
          onChange={(e) => handleOnChange(e, "defaultRating")}
          value={field.defaultRating}
        >
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
        </Select>
      </FormControl>
      <FormControl mt="12px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Rating star color
        </FormLabel>
        <div className="ratingStarColor">
          <input
            type="color"
            className="ratingStarColorInput getColor"
            onChange={(e) => handleOnChange(e, "ratingColor")}
            defaultValue={field.ratingColor || ""}
          />
          <p className="hexcolorCode">{field.ratingColor || ""}</p>
        </div>
      </FormControl>
      <FormControl mt="12px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Add a helptext
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          borderRadius="4px"
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          type="text"
          value={field.helpText}
          placeholder="Enter helptext"
          onChange={(e) => handleOnChange(e, "helpText")}
        />
      </FormControl>
      {`  `}
      <Divider mt="24px" />
      <FormControl mt="24px">
        <FormLabel fontSize="12px" fontWeight="600" color="#475867" mb="4px">
          Form css class{" "}
          <Tooltip
            label="Enter multiple css classes separated by space"
            aria-label="A tooltip"
          >
            <InfoOutlineIcon w="20px" h="20px" ml="4px" />
          </Tooltip>
        </FormLabel>
        <Input
          w="378px"
          h="32px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          borderRadius="4px"
          fontSize="14px"
          fontWeight="600"
          color="#12344D"
          type="text"
          value={styleClasses}
          placeholder="Enter css class name"
          onChange={(e) => handleOnChange(e, "styleClasses")}
        />
      </FormControl>
    </Box>
  );
};

Rating.propTypes = {
  field: PropTypes.object.isRequired,
  handleOnChange: PropTypes.func.isRequired,
};

export default Rating;
